import { urlsConfig } from 'src/configs';
import { EMesajAltTipi, EMesajTipi, EUcNokta } from 'src/types/components/socket.type';
import { MMUSocketMessageType } from 'src/types/mixed.type';

let socket: WebSocket | undefined;

window.addEventListener('unload', function () {
  if (socket && socket.readyState === WebSocket.OPEN) socket.close();
});

export const createConnection = (socketCallback: (socketStatus: boolean) => void) => {
  if (socket === undefined) {
    socket = new WebSocket(urlsConfig.mmuUrl);

    socket.onerror = () => {
      socketCallback(false);
    };

    socket.onopen = () => {
      socketCallback(true);
    };

    socket.onclose = (ev: CloseEvent) => {
      if (ev.reason !== 'reconnect') {
        socketCallback(false);
      }
    };
  }
};

export const listenSocket = (callback: (event: any) => void) => {
  if (socket) {
    socket.onmessage = callback;
  }
};

export const sendMessage = (message: any, isJSON: boolean = true) => {
  setTimeout(() => {
    if (socket) {
      if (isJSON) {
        socket.send(JSON.stringify(message));
      } else {
        socket.send(message);
      }
    }
  }, 1000);
};

export const disconnect = () => {
  if (socket) {
    socket.close(1000, 'reconnect');
    socket = undefined;
  }
};

export const handshakeRequest = (gameId: number) => {
  const msg: MMUSocketMessageType = {
    mesajTipi: EMesajTipi.GENEL,
    mesajAltTipi: EMesajAltTipi.BAGLANTI_TALEBI,
    icerik: {
      istemciTipi: EUcNokta.ISTEMCI_ETECUBE,
      userRole: '6c741fa4-fbec-4b3d-917b-4721f38d1839',
    },
    oyunId: gameId,
  };

  sendMessage(msg);
};

export const forwardingRequest = (oyunId: number) => {
  const msg: MMUSocketMessageType = {
    oyunId: oyunId || 0,
    mesajTipi: EMesajTipi.MMU,
    mesajAltTipi: EMesajAltTipi.YONLENDIRME,
    icerik: {
      ucNokta: EUcNokta.SUNUCU_SURFER,
      istemciTipi: EUcNokta.ISTEMCI_ETECUBE,
    },
  };
  sendMessage(msg);
};
